import React from "react";
import Layout from "../components/Layout";
import { GatsbyImage } from "gatsby-plugin-image";
import { graphql } from "gatsby";
import Section from "../components/Section";
import { Link } from "gatsby";
import SectionTitle from "../components/SectionTitle";
import Card from "../components/NewCard";
import Seo from "../components/Seo";

function dateToWords(str) {
  const date = new Date(str);

  const year = date.getFullYear();
  const month = date.toLocaleString("de-at", { month: "long" });
  const day = date.getDate();

  return `${day}. ${month} ${year}`;
}

const Post = ({ data, location }) => {
  const post = data.article;
  const recentNews = data.recent_news.nodes;

  return (
    <div>
      <Seo
        title={post.frontmatter.title}
        description={post.frontmatter.summary}
        image={
          post.frontmatter.cover.childImageSharp.preview.images.fallback.src
        }
        url={location.pathname}
        date={post.frontmatter.date}
        parentSection="news"
        type="article"
      />
      <Layout>
        <Section className="max-w-screen-md">
          <Link to="/news" className="text-indigo-600 font-bold mb-6 block">
            {"< Zurück zu den News"}
          </Link>

          <article className="mx-auto">
            <header>
              <SectionTitle
                title={post.frontmatter.title}
                desc={
                  <span>
                    <span>{post.frontmatter.author}</span>,{" "}
                    <time
                      dateTime={new Date(post.frontmatter.date).toISOString()}
                    >
                      {dateToWords(post.frontmatter.date)}
                    </time>
                  </span>
                }
              />
            </header>
            <section className="prose lg:prose-lg xl:prose-xl">
              <figure>
                <GatsbyImage
                  loading="eager"
                  className="md:rounded -mx-4 md:mx-0"
                  image={post.frontmatter.cover.childImageSharp.gatsbyImageData}
                  alt={post.frontmatter.picDesc}
                />
                <figcaption>{post.frontmatter.picDesc}</figcaption>
              </figure>
              <div dangerouslySetInnerHTML={{ __html: post.html }} />
            </section>
          </article>
        </Section>

        <Section background>
          <SectionTitle title="Aktuelles" />
          <div className="grid grid-cols-1 md:grid-cols-3 grid-rows-auto gap-6">
            {recentNews
              .flat()
              .slice(0, 3)
              .map((post, index) => {
                return (
                  <Card
                    key={index}
                    loading="eager"
                    image={post.frontmatter.cover}
                    title={post.frontmatter.title}
                    content={post.frontmatter.summary}
                    link={"/posts" + post.fields.slug}
                    category={post.frontmatter.category}
                    date={post.frontmatter.date}
                    author={post.frontmatter.author}
                  />
                );
              })}
          </div>
        </Section>
      </Layout>
    </div>
  );
};
export const query = graphql`
  query ($slug: String!) {
    article: markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        date
        title
        author
        summary
        cover {
          childImageSharp {
            gatsbyImageData(formats: [AUTO, WEBP], width: 768)
            preview: gatsbyImageData(
              formats: [JPG]
              quality: 90
              outputPixelDensities: [1]
              width: 1200
              height: 630
              transformOptions: { cropFocus: ATTENTION }
            )
          }
        }
        picDesc
      }
      fields {
        slug
      }
    }
    recent_news: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/posts/" }
        fields: { slug: { ne: $slug } }
      }
      sort: { frontmatter: { date: DESC } }
      limit: 3
    ) {
      nodes {
        id
        fileAbsolutePath
        frontmatter {
          date
          title
          summary
          category
          author
          cover {
            childImageSharp {
              gatsbyImageData(
                aspectRatio: 1.7777777
                formats: [AUTO, WEBP]
                transformOptions: { cropFocus: NORTH }
                width: 606
              )
            }
          }
        }
        fields {
          slug
        }
      }
    }
  }
`;

export default Post;
